import { Checkbox } from '@commenda/kakashi';
import type { ComponentProps } from 'react';

interface HscCheckboxProps extends ComponentProps<typeof Checkbox> {
  // Whole-percent UBO threshold for this corp's jurisdiction. Interpolated
  // into the caption so non-25% jurisdictions read accurately.
  uboThresholdPercent: number;
}

export const HscCheckbox = ({
  uboThresholdPercent,
  ...checkboxProps
}: HscCheckboxProps) => (
  <div className="flex items-start gap-md">
    <div className="flex items-center justify-center mt-xxs">
      <Checkbox {...checkboxProps} />
    </div>
    <div className="flex flex-1 flex-col gap-xxs">
      <p className="txt-small-bold text-text-primary">
        Has significant control
      </p>
      <p className="txt-small-regular text-text-tertiary">
        Automatically checked if ownership is {uboThresholdPercent}% or more.
        Also check this for board control, voting rights, or other influence.
      </p>
    </div>
  </div>
);
